import Sidebar from "../molecules/Sidebar";

export default function DashboardSidebar() {
  return <Sidebar />;
}
